import {
  MB_PERIOD_COUNTS,
  MIN_MB_PERIOD_LENGTH_DAYS,
  SITE_MATERIAL_SEARCH_FIELDS,
  SITE_TERMINAL_SEARCH_FIELDS,
} from '../constants/sites.constants';

const MS_PER_DAY = 1000 * 60 * 60 * 24;

const matchesSearch = (row, fields, term) =>
  fields.some((field) =>
    String(row[field] ?? '')
      .toLowerCase()
      .includes(term),
  );

export const filterTerminals = (terminals = [], search = '') => {
  const term = search.trim().toLowerCase();
  if (!term) return terminals;

  return terminals.filter((terminal) => matchesSearch(terminal, SITE_TERMINAL_SEARCH_FIELDS, term));
};

const periodLengthInDays = (startDate, endDate) =>
  (new Date(endDate) - new Date(startDate)) / MS_PER_DAY;

export const validateMbPeriodSequence = (timePeriods = []) => {
  if (!timePeriods.length) return 'SITES_MB_PERIOD_ERROR_NO_PERIODS';
  if (!MB_PERIOD_COUNTS.includes(String(timePeriods.length))) return 'SITES_MB_PERIOD_ERROR_COUNT';

  const isIncomplete = timePeriods.some(
    (period) => !period.name || !period.startDate || !period.endDate,
  );
  if (isIncomplete) return 'SITES_MB_PERIOD_ERROR_INCOMPLETE';

  const isTooShort = timePeriods.some(
    (period) => periodLengthInDays(period.startDate, period.endDate) < MIN_MB_PERIOD_LENGTH_DAYS,
  );
  if (isTooShort) return 'SITES_MB_PERIOD_ERROR_TOO_SHORT';

  const overlaps = timePeriods.some(
    (period, index) =>
      index > 0 && new Date(period.startDate) <= new Date(timePeriods[index - 1].endDate),
  );
  if (overlaps) return 'SITES_MB_PERIOD_ERROR_OVERLAP';

  return null;
};

export const filterSiteMaterials = (materials = [], { terminalId = '', search = '' } = {}) => {
  const term = search.trim().toLowerCase();
  if (!terminalId && !term) return materials;

  return materials.filter(
    (material) =>
      (!terminalId || material.terminalIds.some((id) => String(id) === String(terminalId))) &&
      (!term || matchesSearch(material, SITE_MATERIAL_SEARCH_FIELDS, term)),
  );
};
